import React, {Component} from 'react';
import { connect } from 'react-redux';


import Aux from 'hoc/ReactAux/ReactAux';
import TableRow from './TableRow';
import ModalConfirm from 'components/UI/Modal/ModalConfirm';
import './index.css';
import * as actions from 'actions/index';

class Table extends Component  {

  state = {
    showConfirmModal : false,
    cardId : 0
  }

  componentDidMount(){
    this.props.onFetchingCards();
  }

  showConfirmDeleteCardModal = (cardId) => {
    this.setState({showConfirmModal : true, cardId : cardId});
  }

  cancelDeleteCardModal = () => {
    this.setState({showConfirmModal : false, cardId : 0});
  }

  handleConfirmDeleteCard = () =>{
    this.setState({showConfirmModal : false});
    this.props.onDeleteCard(this.state.cardId);
  }

  render (){
    return (
      <Aux>
        {this.state.showConfirmModal ?
          <ModalConfirm
          title={'Confirm delete card'}
          onClose={this.cancelDeleteCardModal}
          onConfirm={this.handleConfirmDeleteCard}>
           <div><h2 style={{textTransform: 'none', fontSize: '20px'}} >Are you sure you want delete this card ?</h2></div>
         </ModalConfirm> : null}
        {this.props.cards.length > 0 ?
        <Aux>
          <h2 className="margin-tittles">Manage Cards</h2>
          <table className='table-cards'>
            <tbody>
              <tr className="table-cards-head" >
                <td>Brand</td>
                <td>Last 4 digits</td>
                <td>Expiry date</td>
                <td></td>
              </tr>
              {this.props.cards.map((row, index) => <TableRow key={index} row={row} deleteCard={this.showConfirmDeleteCardModal} />)}
            </tbody>
          </table>
        </Aux>: null}
      </Aux>
    )
  }

}

const mapStateToProps = state => {
  return {
    cards : state.cartReducer.cart.cards
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchingCards: () => dispatch(actions.fetchingCards()),
    onDeleteCard : (cardId) => dispatch(actions.deleteCard(cardId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Table);



// WEBPACK FOOTER //
// ./src/components/UI/TableCards/index.js